function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from "@apollo/client";
import { useActionSheet } from "@expo/react-native-action-sheet";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import * as ScreenOrientation from "expo-screen-orientation";
import { useCallback } from "react";
import { Image, Platform, StyleSheet, TouchableOpacity } from "react-native";
import { graphql } from "@oui/lib/src/graphql/tada";
import { useI18n } from "../../lib/i18n";
import { launchMediaPickerAsync } from "../../lib/launchMediaPickerAsync";
import { resumableUploadManager } from "../../lib/resumableUploadManager";
import Sentry from "../../sentry";
import { useTheme } from "../../styles";
import { Avatar } from "../Avatar/Avatar";
import { HeaderButtons, HeaderItem } from "../HeaderButtons";
import { Icon } from "../Icon";
import { Heading } from "../Text";
import { View } from "../View";
export var ProfileHeaderQuery = graphql('\n  query ProfileHeader {\n    user {\n      givenName\n      familyName\n      ID\n    }\n    avatar: asset(context: "user", key: "avatar")\n  }\n');
export var ProfileHeaderMutation = graphql('\n  mutation ProfileHeader {\n    uploadResumableAsset(\n      input: { context: "user", key: "avatar", fileName: "avatar.jpeg", uploadType: IMAGE }\n    ) {\n      resumableUploadAssetURI\n    }\n  }\n');
/**
 * Displays the top portion of a user profile screen displaying the user avatar
 * and name. Clicking on the gear icon navigates to `AccountSettings` screen
 *
 *
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃́̀̀̃̇̀̀̃̈̀̀̃̆̀̀̆̃̀̀̃̆̀̀̃̈̀̀̃̇̀̀̂̍̀̀̃̇̀̀̃̂̀̀̆̅̀̀̆́̀̀̂̍̀̀̃̄̀̀̃̀̀̀̆̆̀̀̆̃̀̀̂̍̀̀̆̂̀̀̃̃̀̀̃̆̀̀̃̇̀̀̂̍̀̀̃́̀̀̃̈̀̀̃̅̀̀̆̄̀̀̃̀̀̀̃̂̀̀̆̃̀̀̆́̀̀̆̅̀̀̃̅̀̀̆̄̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃́̀̀̃̀̀̀̃̃̀̀̃̀̀̀̂̍̀̀̃́̀̀̃̄̀̀̃́̀̀̃́̀̀̃̅̀̀̃̅̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃́̀̀̃̆̀̀̃̅̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̆̀̀̃̇̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-19}
 */ export var ProfileHeader = function() {
    var theme = useTheme().theme;
    var $t = useI18n().$t;
    var _useQuery = useQuery(ProfileHeaderQuery), data = _useQuery.data, refetch = _useQuery.refetch;
    var _useMutation = _sliced_to_array(useMutation(ProfileHeaderMutation), 1), uploadAvatar = _useMutation[0];
    var showActionSheetWithOptions = useActionSheet().showActionSheetWithOptions;
    var user = data && data.user;
    var navigate = useNavigation().navigate;
    useFocusEffect(useCallback(function() {
        if (Platform.OS !== 'web') {
            void ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
            return function() {
                return void ScreenOrientation.unlockAsync();
            };
        }
        return;
    }, []));
    var changeProfilePhoto = function() {
        showActionSheetWithOptions({
            options: [
                $t({
                    id: 'Profile_choosePhotoCancelOption',
                    defaultMessage: 'Cancel'
                }),
                $t({
                    id: 'Profile_choosePhotoGalleryOption',
                    defaultMessage: 'Choose from gallery'
                }),
                $t({
                    id: 'Profile_choosePhotoCameraOption',
                    defaultMessage: 'Take a photo'
                })
            ],
            cancelButtonIndex: 0
        }, /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(buttonIndex) {
                var useGallery, result, _avatarResult_data, avatarResult, id, remove, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (typeof buttonIndex !== 'number') return [
                                2
                            ];
                            if (!(buttonIndex > 0)) return [
                                3,
                                7
                            ];
                            useGallery = buttonIndex === 1;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4,
                                launchMediaPickerAsync(useGallery ? 'gallery' : 'camera')
                            ];
                        case 2:
                            result = _state.sent();
                            if (!!result.canceled) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                uploadAvatar({
                                    refetchQueries: [
                                        ProfileHeaderQuery
                                    ]
                                })
                            ];
                        case 3:
                            avatarResult = _state.sent();
                            return [
                                4,
                                resumableUploadManager.uploadFile(result.assets[0].uri, (_avatarResult_data = avatarResult.data) === null || _avatarResult_data === void 0 ? void 0 : _avatarResult_data.uploadResumableAsset.resumableUploadAssetURI)
                            ];
                        case 4:
                            id = _state.sent();
                            remove = resumableUploadManager.addListener(id, function(param) {
                                var percent = param.percent;
                                if (percent === 100) {
                                    void refetch();
                                    remove();
                                }
                            });
                            _state.label = 5;
                        case 5:
                            return [
                                3,
                                7
                            ];
                        case 6:
                            e = _state.sent();
                            Sentry.captureException(e);
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(buttonIndex) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var getEditIcon = function(label) {
        return /*#__PURE__*/ _jsx(HeaderButtons, {
            children: /*#__PURE__*/ _jsx(HeaderItem, {
                title: "",
                testID: "Profile_settingsButton",
                "aria-label": label ? $t({
                    id: 'Profile_settingsButton',
                    defaultMessage: 'Settings'
                }) : '',
                iconName: "settings",
                color: theme.color.gray400,
                onPress: function() {
                    navigate('AccountSettings', {
                        isEditing: 'false'
                    });
                }
            })
        });
    };
    return /*#__PURE__*/ _jsxs(View, {
        children: [
            /*#__PURE__*/ _jsx(View, {
                style: _object_spread_props(_object_spread({}, StyleSheet.absoluteFillObject), {
                    backgroundColor: theme.color.dark,
                    top: 50
                }),
                pointerEvents: "box-none"
            }),
            /*#__PURE__*/ _jsxs(View, {
                style: {
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignItems: 'flex-start'
                },
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            opacity: 0
                        },
                        "aria-hidden": true,
                        children: getEditIcon(false)
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            paddingBottom: 15,
                            alignItems: 'center',
                            gap: 10,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(TouchableOpacity, {
                                testID: "Profile_profilePhotoButton",
                                "aria-label": $t({
                                    id: 'Profile_profilePhotoButton',
                                    defaultMessage: 'Profile photo'
                                }),
                                style: {
                                    width: 100,
                                    height: 100
                                },
                                role: "button",
                                onPress: changeProfilePhoto,
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        name: "camera",
                                        color: theme.color.primary100,
                                        style: {
                                            bottom: 12,
                                            left: 40,
                                            position: 'absolute',
                                            zIndex: 1
                                        }
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.avatar) ? /*#__PURE__*/ _jsx(Image, {
                                        style: {
                                            width: 100,
                                            height: 100,
                                            borderRadius: 50,
                                            backgroundColor: theme.color.accentTwo100
                                        },
                                        source: {
                                            uri: data === null || data === void 0 ? void 0 : data.avatar
                                        },
                                        testID: "Profile_avatar"
                                    }) : /*#__PURE__*/ _jsx(Avatar, {
                                        name: user ? "".concat(user.givenName, " ").concat(user.familyName) : '',
                                        size: 100,
                                        round: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Heading, {
                                text: user ? "".concat(user.givenName, " ").concat(user.familyName) : '',
                                level: 1,
                                variant: "light"
                            })
                        ]
                    }),
                    getEditIcon(true)
                ]
            })
        ]
    });
};
